import type { AccessPair } from '@/shared/lib'

/**
 * `GET /v1/serials` — проверка серийного номера. Маршрут закрыт правом `serial.view` (есть у всех
 * клиентов и у менеджера). Модификатора «от имени» у ресурса нет: `?client=` ручка отвергает `400`,
 * поэтому `onBehalf`/`accepts` в паре не заданы. Полнота строк — отдельное право `serial.full.view`,
 * и это не гейт маршрута, а видимость колонок (правило 8): без него бэк сам режет поля и шлёт notice.
 */
export const SERIALS_ACCESS: AccessPair = { own: 'serial.view' }
